__turbopack_context__.v({
  "container": "Tekstblokk-module__EEe6eq__container",
  "content": "Tekstblokk-module__EEe6eq__content",
  "darkText": "Tekstblokk-module__EEe6eq__darkText",
  "lightText": "Tekstblokk-module__EEe6eq__lightText",
  "styledBlockContent": "Tekstblokk-module__EEe6eq__styledBlockContent",
});
